<div class="container-fluid" style=" padding-right: 0px; padding-left: 0px">
  <app-nav-menu></app-nav-menu>
</div>
<div class="container" id="desktop">
  <div class="row mt-2">
    <div class="col-md-12" style="font-size:2.6em; font-weight:bold">
      Court Documents
    </div>
  </div>

  <div class="row indentContent">
    <div class="col-md-12">
      <ul>
        <li>
          <a href="../../../assets/docs/GoodRx Criteo Claim Form Draft V3 - Blank.pdf"
             target="_blank" style="color:#006cDb">
            Claim Form
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/GoodRx Criteo - Long Form Notice V2.pdf"
             target="_blank" style="color:#006cDb">
            Long Form Notice
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/GoodRx Criteo - Short Form Notice V2.pdf"
             target="_blank" style="color:#006cDb">
            Short Form Notice
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/0379. (09-08-2026) ORDER PRELIMINARILY APPROVING THE PROPOSED CLASS ACTION SETTLEMENT, SCHEDULING HEARING FOR FINAL APP.pdf"
             target="_blank" style="color:#006cDb">
            Preliminary Approval Order
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/Settlement Agreement.pdf"
             target="_blank" style="color:#006cDb">
            Settlement Agreement
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/Addendum Settlement Agreement.pdf"
             target="_blank" style="color:#006cDb">
            Addendum Settlement Agreement
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/JP Dec.pdf"
             target="_blank" style="color:#006cDb">
            Declaration of J. Parks Regarding the Proposed Notice Plan
          </a>
        </li>
      </ul> 
    </div>
  </div>
</div>

<div class="container" id="mobile">
  <div class="row mt-2">
    <div class="col-md-12" style="font-size:2.0em; font-weight:bold">
      Court Documents
    </div>
  </div>

  <div class="row indentContent">
    <div class="col-md-12">
      <ul>
        <li>
          <a href="../../../assets/docs/GoodRx Criteo Claim Form Draft V3 - Blank.pdf"
             target="_blank" style="color:#006cDb">
            Claim Form
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/2026.09.03  Settlement Exh. B - Long Form Notice.pdf"
             target="_blank" style="color:#006cDb">
            Long Form Notice
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/2026.09.03 Settlement Exh. C - Short Form Notice.pdf"
             target="_blank" style="color:#006cDb">
            Short Form Notice
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/0379. (09-08-2026) ORDER PRELIMINARILY APPROVING THE PROPOSED CLASS ACTION SETTLEMENT, SCHEDULING HEARING FOR FINAL APP.pdf"
             target="_blank" style="color:#006cDb">
            Preliminary Approval
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/Settlement Agreement.pdf"
             target="_blank" style="color:#006cDb">
            Settlement Agreement
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/Addendum Settlement Agreement.pdf"
             target="_blank" style="color:#006cDb">
            Addendum Settlement Agreement
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/JP Dec.pdf"
             target="_blank" style="color:#006cDb">
            Declaration of J. Parks Regarding the Proposed Notice Plan
          </a>
        </li>
      </ul>
    </div>
  </div>
</div>






